import type { ReactNode } from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  compact?: boolean;
  id?: string;
  className?: string;
  'aria-label'?: string;
}

/** Interrupteur iOS/Android — à placer dans un <label> pour que le texte bascule aussi. */
export function Switch({
  checked,
  onChange,
  disabled,
  compact,
  id,
  className,
  'aria-label': ariaLabel,
}: SwitchProps) {
  return (
    <span
      className={[
        'ios-switch',
        compact ? 'ios-switch--compact' : '',
        className ?? '',
      ].filter(Boolean).join(' ')}
    >
      <input
        id={id}
        type="checkbox"
        role="switch"
        className="ios-switch-input"
        checked={checked}
        disabled={disabled}
        aria-checked={checked}
        aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="ios-switch-track" aria-hidden />
    </span>
  );
}

interface SwitchRowProps extends Omit<SwitchProps, 'aria-label' | 'id'> {
  label: ReactNode;
}

export function SwitchRow({
  label,
  className,
  disabled,
  ...switchProps
}: SwitchRowProps) {
  return (
    <label
      className={['ios-switch-row', className ?? ''].filter(Boolean).join(' ')}
    >
      <span className="ios-switch-row-label">{label}</span>
      <Switch disabled={disabled} {...switchProps} />
    </label>
  );
}
